import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Header from "./header";
import MenuBar from "./navbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./invoiceform.css";
import swal from "sweetalert";
import axios from "axios";
import {
  BASE_URL,
  PRODUCTS_LIST,
  HSN_LIST,
  GST_LIST,
  PER_QTY_RATE_LIST,
  TAX_TYPE_LIST,
  TAX_STATE_LIST,
  PRODUCT_HSN_MAPPER,
  isTokenValid,
} from "./utility";
import { Navigate } from "react-router-dom";
import Select from "react-select";
const InvoiceForm = (props) => {
  const [buyerinputValue, setbuyerinputValue] = useState("");
  const [consigneeinputValue, setconsigneeinputValue] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [buyerSuggestions, setbuyerSuggestions] = useState([]);
  const [consigneeSuggestions, setconsigneeSuggestions] = useState([]);
  const [productRowsVisible, setProductRowsVisible] = useState(1);
  const maxProductRows = 7;
  const productFieldIndexes = Array.from(
    { length: productRowsVisible },
    (_, index) => index + 1
  );
  const productOptions = PRODUCTS_LIST.map((item) => ({
    value: item.value,
    label: item.text,
  }));
  const handlebuyerAddressInput = (e) => {
    const value = e.target.value;
    setbuyerinputValue(value);
    if (value.length >= 4) {
      fetchSuggestions("buyerAddress", value);
    } else {
      setbuyerSuggestions([]);
    }
  };
  const handleconsigneeAddressInput = (e) => {
    const value = e.target.value;
    setconsigneeinputValue(value);
    if (value.length >= 4) {
      fetchSuggestions("consigneeAddress", value);
    } else {
      setconsigneeSuggestions([]);
    }
  };
  const fetchSuggestions = async (field, query) => {
    try {
      const response = await axios.get(
        `${BASE_URL}getCustomerRecords/${field}/${query}`
      );
      if (field === "buyerAddress") {
        setbuyerSuggestions(response.data);
      } else if (field === "consigneeAddress") {
        setconsigneeSuggestions(response.data);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };
  const handleSuggestionClick = (fieledtype, address) => {
    if (fieledtype === "buyer") {
      setbuyerSuggestions([]);
      setbuyerinputValue(address);
      invoiceGeneration.buyerAddress = address;
    } else if (fieledtype === "consignee") {
      setconsigneeSuggestions([]);
      setconsigneeinputValue(address);
      invoiceGeneration.consigneeAddress = address;
    }
  };
  const [invoiceGeneration, setInvoiceGeneration] = useState({
    consigneeAddress: "",
    buyerAddress: "",
    invoiceNo: "",
    orderDate: new Date(),
    referenceNumber: "",
    otherRefrences: "",
    buyerOrderNumber: "",
    buyerDate: new Date(),
    dispatchDocNo: "",
    deliveryNoteDate: new Date(),
    dispatchedThrough: "",
    destination: "",
    termsOfDelivery: "",
    productname1: "",
    hsn1: "",
    qty1: "",
    rate1: "",
    ratePerQty1: "",
    gst1: "",
    pcomment1: "",
    productname2: "",
    hsn2: "",
    qty2: "",
    rate2: "",
    ratePerQty2: "",
    gst2: "",
    pcomment2: "",
    productname3: "",
    hsn3: "",
    qty3: "",
    rate3: "",
    ratePerQty3: "",
    gst3: "",
    pcomment3: "",
    productname4: "",
    hsn4: "",
    qty4: "",
    rate4: "",
    ratePerQty4: "",
    gst4: "",
    pcomment4: "",
    productname5: "",
    hsn5: "",
    qty5: "",
    rate5: "",
    ratePerQty5: "",
    gst5: "",
    pcomment5: "",
    productname6: "",
    hsn6: "",
    qty6: "",
    rate6: "",
    ratePerQty6: "",
    gst6: "",
    pcomment6: "",
    productname7: "",
    hsn7: "",
    qty7: "",
    rate7: "",
    ratePerQty7: "",
    gst7: "",
    pcomment7: "",
    type: props.type,
    taxType: "",
    taxState: "",
  });

  const generateInvoice = async (event) => {
    event.preventDefault();
    if (isGenerating) return;

    if (validateInputs()) {
      const invoicePayload = {
        ...invoiceGeneration,
        buyerAddress:
          invoiceGeneration.buyerAddress === ""
            ? buyerinputValue
            : invoiceGeneration.buyerAddress,
        consigneeAddress:
          invoiceGeneration.consigneeAddress === ""
            ? consigneeinputValue
            : invoiceGeneration.consigneeAddress,
      };

      console.log("Input data " + JSON.stringify(invoicePayload));
      setIsGenerating(true);

      try {
        const res = await fetch(BASE_URL + "generateInvoice", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
          body: JSON.stringify(invoicePayload),
        });

        if (res.status === 401) {
          localStorage.removeItem("token");
          window.location.href = "/auth";
          return;
        }

        if (!res.ok) {
          throw new Error("Invoice generation failed");
        }

        const blob = await res.blob();
        var file = window.URL.createObjectURL(blob);
        window.location.assign(file);
      } catch (error) {
        console.error("Error generating invoice:", error);
        swal("Unable to generate invoice. Please try again.");
      } finally {
        setIsGenerating(false);
      }
    }
  };

  const productSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
      minWidth: 0,
    }),
    control: (provided) => ({
      ...provided,
      width: "100%",
      minHeight: "38px",
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "black",
      padding: "10px 12px",
      textAlign: "left",
      backgroundColor: state.isFocused ? "#f0f0f0" : "white",
    }),
    menu: (provided) => ({
      ...provided,
      left: 0,
      right: "auto",
      width: "100%",
      zIndex: 10,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "6px 0",
    }),
  };
  const getProductField = (field, index) =>
    invoiceGeneration[`${field}${index}`];
  const isProductRowComplete = (index) =>
    getProductField("productname", index) !== "" &&
    getProductField("hsn", index) !== "" &&
    getProductField("gst", index) !== "" &&
    getProductField("qty", index) !== "" &&
    getProductField("rate", index) !== "" &&
    getProductField("ratePerQty", index) !== "";
  const hasProductRowInput = (index) =>
    ["productname", "hsn", "gst", "qty", "rate", "ratePerQty"].some(
      (field) => getProductField(field, index) !== ""
    );
  const productRowNames = {
    2: "second",
    3: "third",
    4: "4th",
    5: "5th",
    6: "6th",
    7: "7th",
  };
  const validateInputs = () => {
    if (!isProductRowComplete(1)) {
      swal("Atleast fill one product detail completely !!");
      return false;
    }

    for (let index = 2; index <= maxProductRows; index += 1) {
      if (hasProductRowInput(index) && !isProductRowComplete(index)) {
        swal(
          `Please fill ${productRowNames[index]} product detail completely !!`
        );
        return false;
      }
    }

    return true;
  };

  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name.includes("productname")) {
      let matches = name.match(/(\d+)/);
      setInvoiceGeneration({
        ...invoiceGeneration,
        [name]: value,
        ["hsn" + matches[0]]: PRODUCT_HSN_MAPPER[value] || "",
      });
    } else {
      setInvoiceGeneration({ ...invoiceGeneration, [name]: value });
    }
  };
  const handleOrderDateInput = (e) => {
    const dateVal = e;
    setInvoiceGeneration({ ...invoiceGeneration, orderDate: dateVal });
  };
  const handleBuyerDateInput = (e) => {
    const dateVal = e;
    setInvoiceGeneration({ ...invoiceGeneration, buyerDate: dateVal });
  };
  const handleDeliveryNoteDateInput = (e) => {
    const dateVal = e;
    setInvoiceGeneration({ ...invoiceGeneration, deliveryNoteDate: dateVal });
  };
  const addProductRow = () => {
    setProductRowsVisible((currentRows) =>
      Math.min(currentRows + 1, maxProductRows)
    );
  };
  const renderProductRow = (index) => (
    <div className="invoice-product-line" key={index}>
      <Form.Group className="invoice-product-row">
        <Select
          options={productOptions}
          value={
            productOptions.find(
              (option) =>
                option.value === invoiceGeneration[`productname${index}`]
            ) || null
          }
          onChange={(selectedOption) =>
            handleInput({
              target: {
                name: `productname${index}`,
                value: selectedOption ? selectedOption.value : "",
              },
            })
          }
          name={`productname${index}`}
          id={`productname${index}`}
          placeholder="Select product..."
          isSearchable
          styles={productSelectStyles}
        />
        <Form.Control
          autoComplete="off"
          type="text"
          value={invoiceGeneration[`pcomment${index}`]}
          onChange={handleInput}
          name={`pcomment${index}`}
          id={`pcomment${index}`}
          placeholder="Description"
        />

        <select
          className="form-control"
          value={invoiceGeneration[`hsn${index}`]}
          onChange={handleInput}
          name={`hsn${index}`}
          id={`hsn${index}`}
          placeholder="Enter HSN/SAC"
          required={index === 1}
        >
          {HSN_LIST.map((item) => {
            return (
              <option key={item.value} value={item.value}>
                {item.text}
              </option>
            );
          })}
        </select>

        <Form.Control
          autoComplete="off"
          type="number"
          min="0"
          value={invoiceGeneration[`qty${index}`]}
          onChange={handleInput}
          name={`qty${index}`}
          id={`qty${index}`}
          placeholder="Enter Quantity"
          required={index === 1}
        />

        <Form.Control
          type="number"
          min="0"
          step="0.01"
          value={invoiceGeneration[`rate${index}`]}
          onChange={handleInput}
          name={`rate${index}`}
          id={`rate${index}`}
          placeholder="Enter Rate"
          required={index === 1}
        />

        <select
          className="form-control"
          value={invoiceGeneration[`ratePerQty${index}`]}
          onChange={handleInput}
          name={`ratePerQty${index}`}
          id={`ratePerQty${index}`}
          required={index === 1}
        >
          {PER_QTY_RATE_LIST.map((item) => {
            return (
              <option key={item.value} value={item.value}>
                {item.text}
              </option>
            );
          })}
        </select>

        <select
          className="form-control"
          value={invoiceGeneration[`gst${index}`]}
          onChange={handleInput}
          name={`gst${index}`}
          id={`gst${index}`}
          required={index === 1}
        >
          {GST_LIST.map((item) => {
            return (
              <option key={item.value} value={item.value}>
                {item.text}
              </option>
            );
          })}
        </select>
      </Form.Group>
    </div>
  );
  const myStyle = {
    color: "white",
    backgroundColor: "",
    padding: "5%",
    fontFamily: "Sans-Serif",
    width: "100%",
    margin: "0 auto",
  };
  if (!isTokenValid()) return <Navigate to="/auth" replace />;
  else
    return (
      <div
        className="invoice-form-page"
        style={{ backgroundImage: `url(${BASE_URL + "download/general/bg"})` }}
      >
        <Header />
        <MenuBar />
        <div className="invoice-form-heading">
          <h2>{props.desc}</h2>
        </div>

        <div className="invoice-form-shell" style={myStyle}>
          <Form className="invoice-form" onSubmit={generateInvoice}>
            <Form.Group className="mb-3">
              <Form.Label>Tax State</Form.Label>
              <select
                className="form-control"
                value={invoiceGeneration.taxState}
                onChange={handleInput}
                name="taxState"
                id="taxState"
                required
              >
                {TAX_STATE_LIST.map((item) => {
                  return (
                    <option key={item.value} value={item.value}>
                      {item.text}
                    </option>
                  );
                })}
              </select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tax Type</Form.Label>
              <select
                className="form-control"
                value={invoiceGeneration.taxType}
                onChange={handleInput}
                name="taxType"
                id="taxType"
                required
              >
                {TAX_TYPE_LIST.map((item) => {
                  return (
                    <option key={item.value} value={item.value}>
                      {item.text}
                    </option>
                  );
                })}
              </select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Consignee Address</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={consigneeinputValue}
                onChange={handleconsigneeAddressInput}
                name="consigneeAddress"
                id="consigneeAddress"
                placeholder="Enter Consignee Address"
                required
              />
              {consigneeSuggestions.length > 0 && (
                <ol
                  className="consigneesuggestions invoice-suggestions"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "10px",
                  }}
                >
                  {consigneeSuggestions.map((address) => (
                    <li
                      key={address}
                      onClick={() =>
                        handleSuggestionClick("consignee", address)
                      }
                    >
                      {address}
                    </li>
                  ))}
                </ol>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Invoice Number</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.invoiceNo}
                onChange={handleInput}
                name="invoiceNo"
                id="invoiceNo"
                placeholder="Enter Invoice Number"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Buyer Address</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={buyerinputValue}
                onChange={handlebuyerAddressInput}
                name="buyerAddress"
                id="buyerAddress"
                placeholder="Enter Buyer Address"
                required
              />
              {buyerSuggestions.length > 0 && (
                <ol
                  className="buyersuggestions invoice-suggestions"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "10px",
                  }}
                >
                  {buyerSuggestions.map((address) => (
                    <li
                      key={address}
                      onClick={() => handleSuggestionClick("buyer", address)}
                    >
                      {address}
                    </li>
                  ))}
                </ol>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <DatePicker
                autoComplete="off"
                dateformat="MM/dd/yyyy"
                selected={invoiceGeneration.orderDate}
                value={invoiceGeneration.orderDate}
                onChange={handleOrderDateInput}
                name="orderDate"
                id="orderDate"
                placeholder="Enter Date"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Reference No</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.referenceNumber}
                onChange={handleInput}
                name="referenceNumber"
                id="referenceNumber"
                placeholder="Enter Reference No"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Other Refrences</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.otherRefrences}
                onChange={handleInput}
                name="otherRefrences"
                id="otherRefrences"
                placeholder="Enter Other Refrences"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Buyer Order No</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.buyerOrderNumber}
                onChange={handleInput}
                name="buyerOrderNumber"
                id="buyerOrderNumber"
                placeholder="Enter Buyer Order No"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Buyer Date</Form.Label>
              <DatePicker
                autoComplete="off"
                dateformat="MM/dd/yyyy"
                selected={invoiceGeneration.buyerDate}
                value={invoiceGeneration.buyerDate}
                onChange={handleBuyerDateInput}
                name="buyerDate"
                id="buyerDate"
                placeholder="Enter Buyer Date"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Dispatch Doc No</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.dispatchDocNo}
                onChange={handleInput}
                name="dispatchDocNo"
                id="dispatchDocNo"
                placeholder="Enter Dispatch Doc No"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Delivery Note Date</Form.Label>
              <DatePicker
                autoComplete="off"
                dateformat="MM/dd/yyyy"
                selected={invoiceGeneration.deliveryNoteDate}
                value={invoiceGeneration.deliveryNoteDate}
                onChange={handleDeliveryNoteDateInput}
                name="deliveryNoteDate"
                id="deliveryNoteDate"
                placeholder="Enter Delivery Note Date"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Dispatched Through</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.dispatchedThrough}
                onChange={handleInput}
                name="dispatchedThrough"
                id="dispatchedThrough"
                placeholder="Enter Dispatched Through"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Destination</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={invoiceGeneration.destination}
                onChange={handleInput}
                name="destination"
                id="destination"
                placeholder="Enter Destination"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Terms of Delivery</Form.Label>
              <Form.Control
                autoComplete="off"
                type="textarea"
                value={invoiceGeneration.termsOfDelivery}
                onChange={handleInput}
                name="termsOfDelivery"
                id="termsOfDelivery"
                placeholder="Enter Terms of Delivery"
              />
            </Form.Group>
            <Form.Group className="mb-3 invoice-products-group">
              <div className="invoice-products-heading">
                <Form.Label>Select Products</Form.Label>
              </div>
              {productFieldIndexes.map(renderProductRow)}
              <div className="invoice-products-actions">
                <Button
                  className="invoice-add-product-button"
                  variant="success"
                  type="button"
                  onClick={addProductRow}
                  disabled={productRowsVisible >= maxProductRows}
                  aria-label="Add product row"
                >
                  {productRowsVisible >= maxProductRows
                    ? "Max products selected"
                    : "+ Add More"}
                </Button>
              </div>
            </Form.Group>
            <Button
              className={`invoice-submit-button${
                isGenerating ? " invoice-submit-button--loading" : ""
              }`}
              variant="primary"
              autoComplete="off"
              disabled={isGenerating}
              aria-busy={isGenerating}
              type="submit"
            >
              {isGenerating ? (
                <>
                  <span className="invoice-submit-spinner" aria-hidden="true" />
                  <span>Generating...</span>
                </>
              ) : (
                "Generate Invoice"
              )}
            </Button>
          </Form>
          <div>&nbsp;</div>
        </div>
      </div>
    );
};
export default InvoiceForm;
